/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Headerstyles } from './headerstyles';
import dataSlice from '../../state/slices/data';

const buttonList = [
  { id: 'round32', label: 'Round of 32' },
  { id: 'round16', label: 'Round of 16' },
  { id: 'quarterfinals', label: 'Quarterfinals' },
  { id: 'semifinals', label: 'Semifinals' },
  { id: 'final', label: 'Final' },
];

export default function Header() {
  const dispatch = useDispatch();
  const activeButton = useSelector((state) => state.data.activeButton);
  const navRef = useRef(null);
  const buttonRefs = useRef({});

  useEffect(() => {
    const nav = navRef.current;
    const activeNode = buttonRefs.current[activeButton];

    if (
      !nav ||
      !activeNode ||
      !window.matchMedia('(max-width: 767px)').matches
    ) {
      return;
    }

    const targetLeft =
      activeNode.offsetLeft - (nav.clientWidth - activeNode.offsetWidth) / 2;

    const maxScrollLeft = nav.scrollWidth - nav.clientWidth;
    nav.scrollTo({
      left: Math.max(0, Math.min(targetLeft, maxScrollLeft)),
      behavior: 'smooth',
    });
  }, [activeButton]);

  return (
    <Headerstyles>
      <img
        className="world-cup-logo"
        src="images/fwc2026_cl_cmykt_m_rv.png"
        alt="World Cup 2026 Logo"
      />
      <div className="title-wrap">
        <div className="title">Knockout Stage</div>
      </div>

      <nav ref={navRef}>
        {buttonList.map((button) => (
          <button
            key={button.id}
            id={button.id}
            ref={(node) => {
              if (node) {
                buttonRefs.current[button.id] = node;
              }
            }}
            type="button"
            className={button.id === activeButton ? 'active' : ''}
            onClick={() =>
              dispatch(dataSlice.actions.setActiveButton(button.id))
            }
          >
            {button.label}
          </button>
        ))}
      </nav>
    </Headerstyles>
  );
}
